import { isUseSameDomain } from '@/common/utils/index';

const getSubDomain = (curSubdomain, domain) => {
  if (curSubdomain.startsWith('ta-')) {
    return {
      page: 'ta-www',
      api: 'test-inner-web-gateway',
    };
  }
  if (curSubdomain.startsWith('bggray-')) {
    return {
      page: 'bggray-www',
      api: 'gray-web-gateway',
    };
  }

  if (['linhty.xyz', 'hzmk.site'].includes(domain)) {
    return {
      page: 'm',
      api: 'ta',
    };
  }

  if (domain === 'cloudfront.net') {
    return {
      page: 'd1e5ml8xtgdvj3',
      api: 'd2ymiio14rfyj6',
    };
  }

  return {
    page: 'www',
    api: 'ta',
  };
};

export const getAuthUrl = (lang = 'en') => {
  const fullDomain = window.location.hostname;

  const testUrl = {
    page: `https://ta-www.bigo.tv/ssr/login-iframe?lang=${lang}&source=agent`,
    authPage: `https://ta-www.bigo.tv/ssr/auth-iframe?source=agent`,
    api: 'https://test-inner-web-gateway.bigo.tv',
  };

  // 排除 IP 地址和 localhost
  if (
    fullDomain === 'localhost' ||
    /^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$/.test(fullDomain) ||
    /^[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+:[0-9]+$/.test(fullDomain)
  ) {
    return testUrl;
  }

  if (isUseSameDomain()) {
    return {
      page: `/ssr/login-iframe?lang=${lang}&source=agent`,
      authPage: `/ssr/auth-iframe?source=agent`,
      api: `https://d2ymiio14rfyj6.cloudfront.net`,
    };
  }

  // 分割域名为部分
  const domainParts = fullDomain.split('.');

  // 检查域名是否有足够的部分
  if (domainParts.length >= 3) {
    // 获取二级域名
    const subdomain = domainParts[0];
    const domain = `${domainParts[1]}.${domainParts[2]}`;
    return {
      page: `https://${
        getSubDomain(subdomain, domain).page
      }.${domain}/ssr/login-iframe?lang=${lang}&source=agent`,
      authPage: `https://${
        getSubDomain(subdomain, domain).page
      }.${domain}/ssr/auth-iframe?source=agent`,
      api: `https://${getSubDomain(subdomain, domain).api}.${domain}`,
    };
  }
  return testUrl;
};
